
import { Placement } from '@post-office/placements-frontend/atlas-side-nav-growth-item';
export default Placement;
